import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/api/client.js";
import { useOrignalUi } from "@/hooks/useOrignalUi.js";

export function Hunt2026Page() {
  const { ui } = useOrignalUi();
  const t = ui.hunt;
  const [data, setData] = useState(null);

  useEffect(() => {
    api("/api/bootstrap").then(setData).catch(() => {});
  }, []);

  const hunt = data?.hunt || {};
  const phases = hunt.phases || [];
  const prospect = hunt.prospection || {};
  const nextItems = (hunt.next_step?.items || []).slice(0, 5);
  const after = hunt.after_hunt || {};

  function phaseStatus(p) {
    if (p.status === "completed") return t.completed;
    if (p.current || p.status === "current") return t.phaseNow;
    return t.upcoming;
  }

  return (
    <main className="og-home og-home--chapter" data-testid="page-hunt">
      <section className="og-panel">
        <p className="og-kicker">{t.ourHunt}</p>
        <h1>{t.title}</h1>
        <p>{t.subtitle}</p>
        <ol className="og-hunt-timeline" data-testid="hunt-timeline">
          {phases.map((p) => (
            <li key={p.id} className={p.current ? "is-current" : p.status === "completed" ? "is-done" : "is-soon"} data-testid={`phase-${p.id}`}>
              <strong>{t.phases[p.id] || t.rail[p.id]}</strong>
              <small>{phaseStatus(p)}</small>
            </li>
          ))}
        </ol>
      </section>

      <section className="og-panel" data-testid="hunt-prep-prospect">
        <p className="og-kicker">{t.prepProspectTitle}</p>
        <p><span className="og-badge og-badge--done">{t.completed}</span></p>
        <p>Chalet Desrochers · {t.prepTopics.transport} · {t.prepTopics.food} · {t.prepTopics.maps}</p>
      </section>

      <section className="og-panel" data-testid="hunt-prospect-card">
        <p className="og-kicker">{t.ourProspect}</p>
        <h2>{t.prospectTitle}</h2>
        <p>{prospect.dates}</p>
        <p><span className="og-badge og-badge--done">{t.completed}</span></p>
        <p>{prospect.lodge} · {prospect.sector}</p>
        <p data-testid="prospect-people">{t.sevenPeople}</p>
        <div className="og-home__actions">
          <Link className="og-btn og-btn--primary" to="/chasse-2026/prospection">{t.openProspect}</Link>
          <Link className="og-btn" to="/photos">{t.tabPhotos}</Link>
          <Link className="og-btn" to="/territoire">{t.tabMap}</Link>
        </div>
      </section>

      <section className="og-panel" data-testid="hunt-prep-card">
        <p className="og-kicker">{t.prepHuntTitle}</p>
        <p><span className="og-badge">{t.phaseNow}</span></p>
        <p>{t.nowPreparing}</p>
        <ul className="og-home__next-list">
          {nextItems.map((row) => (
            <li key={row.id}><Link to={row.to}>{row.label}</Link></li>
          ))}
        </ul>
      </section>

      <section className="og-panel" data-testid="hunt-future-card">
        <p className="og-kicker">{t.ourHunt}</p>
        <h2>{t.huntLiveTitle}</h2>
        <p><span className="og-badge og-badge--soon">{t.upcoming}</span></p>
        <p data-testid="hunt-window">{t.datesLine}</p>
        <p data-testid="hunt-depart">{t.departDay} · {t.departLine}</p>
        <p data-testid="hunt-arrive">{t.arriveLine}</p>
        <p data-testid="hunt-field">{t.fieldMapLabel} · {t.fieldMap}</p>
        <p>{t.sixHunters}</p>
      </section>

      <section className="og-panel" data-testid="hunt-after-card">
        <p className="og-kicker">{t.afterHuntTitle}</p>
        <p><span className="og-badge og-badge--soon">{t.upcoming}</span></p>
        <p>{(after.destinations || ["photos", "results", "souvenirs", "expenses", "observations", "final"]).map((id) => t.afterDest[id] || id).join(" · ")}</p>
      </section>
    </main>
  );
}
